import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Footer from './components/Footer';
import ComplianceForm from './components/ComplianceForm';
import Dashboard from './components/Dashboard';
import LoginPage from './components/LoginPage';

function App() {
  const [reports, setReports] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  // ✅ Load session from sessionStorage with expiry check
  useEffect(() => {
    const data = sessionStorage.getItem('userTokenData');
    if (data) {
      const { token, expiresAt } = JSON.parse(data);
      if (Date.now() < expiresAt) {
        fetch('https://app.smartcompliance.ai/api/UserActions/GetUser', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ UserToken: token })
        })
          .then((res) => res.json())
          .then((userData) => {
            if (userData?.loginMessage === 'SUCCESS') {
              setUser(userData);
              setIsAuthenticated(true);
            } else {
              handleLogout(); // Invalid session
            }
          })
          .catch((err) => {
            console.error('Session restore error:', err);
            handleLogout(); // Cleanup on error
          });
      } else {
        handleLogout(); // Expired
      }
    }
  }, []);

  const addReport = (report) => {
    setReports([...reports, report]);
  };

  const deleteReport = (index) => {
    const updatedReports = reports.filter((_, i) => i !== index);
    setReports(updatedReports);
  };

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    sessionStorage.clear();
  };

  return (
    <Router>
      <Navbar isAuthenticated={isAuthenticated} user={user} onLogout={handleLogout} />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <About />
              <Services />
              <Footer />
            </>
          }
        />
        <Route
          path="/login"
          element={
            !isAuthenticated ? (
              <LoginPage onLogin={handleLogin} />
            ) : (
              <Navigate to="/dashboard" />
            )
          }
        />
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              <>
                <ComplianceForm onAddReport={addReport} user={user} />
                <Dashboard reports={reports} onDeleteReport={deleteReport} />
                <Footer />
              </>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
